import { createBrowserRouter } from 'react-router-dom'
import routes from './routes'

const paths = ['/c1/', '/c2/', '/g1/']
const { pathname } = location
const basename = paths.find((path) => pathname.startsWith(path)) || '/'
const router = createBrowserRouter(routes, { basename })

export default router
